import { forEach } from 'lodash';
import Cookie from '../../helpers/Cookies';
// import Observable from "../../helpers/Observable";
// import { mobile } from "../../constants";
// @snippet
/**
 * @class DynamicYield
 */

// const observer = new Observable();

class DynamicYield {
  // constructor(observer) {
  //   this.observer = observer;
  //   this.loadAssets();

  //   this.eventLogin();
  //   this.eventSignup();
  //   this.eventsView();
  //   this.eventsClick();

  //   // DynamicYield.getDataApi()
  // }

  // async loadAssets() {
  //   await import(
  //     /* webpackChunkName: "plugins-swiper" */ `../../../sass2/chunks/plugins/swiper.scss`
  //   );
  //   await import(
  //     /* webpackChunkName: "helpers_slider" */ `../../helpers/Slider.js`
  //   );
  // }

  // eventLogin() {
  //   if (
  //     Cookie.get('signin-mail') &&
  //     Cookie.get('customer_auth_session_created_at') &&
  //     window?.gld_dy?.enabled
  //   ) {
  //     window.gld_dy.event({
  //       name: 'Login',
  //       properties: {
  //         dyType: 'login-v1',
  //         hashedEmail: DYO.dyhash.sha256(
  //           `${Cookie.get('signin-mail')}`.toLowerCase()
  //         ), // SHA256 encoding of the lowercase email, if known (optional)
  //       },
  //     });
  //     Cookie.set({
  //       name: 'signin-mail',
  //       value: true,
  //       expires: -1,
  //     });
  //   }
  // }
  // eventSignup() {
  //   if (
  //     Cookie.get('signup-mail') &&
  //     Cookie.get('customer_auth_session_created_at')
  //   ) {
  //     window.gld_dy.event({
  //       name: 'Signup',
  //       properties: {
  //         dyType: 'signup-v1',
  //         hashedEmail: DYO.dyhash.sha256(
  //           `${Cookie.get('signup-mail')}`.toLowerCase()
  //         ), // SHA256 encoding of the lowercase email, if the email is known
  //       },
  //     });
  //     Cookie.set({
  //       name: 'signup-mail',
  //       value: true,
  //       expires: -1,
  //     });
  //   }
  // }

  // eventsClick() {
  //   const area = document.querySelector('body');
  //   area.addEventListener('click', (event) => {
  //     const selector = '.dy-custom-event--click';
  //     let item = event.target.closest(selector);
  //     if (!item && event.target.classList.contains(selector.substring(1))) {
  //       item = event.target;
  //     }

  //     if (item) {
  //       DynamicYield.sendEvent(item, { name: 'click' });
  //     }
  //   });
  // }

  // eventsView() {
  //   this.observer.subscribe('.dy-custom-event--view', async (element) => {
  //     DynamicYield.sendEvent(element);
  //   });
  // }

  // static sendEvent(element, props = false) {
  //   if (
  //     window?.gld_dy?.enabled === true &&
  //     window.gld_dy.event &&
  //     element &&
  //     !element.classList.contains('dy-custom-event--done')
  //   ) {
  //     if (window.gld_dy.event(element, props)) {
  //       element.classList.add('dy-custom-event--done');
  //     }
  //   }
  // }

  static async reportUserEngagement(parameters) {
    if (window?.DY?.dyid && parameters?.decisionId && parameters?.apiKey) {
      const url =
        'https://direct-collect.dy-api.com/v2/collect/user/engagement';
      // const url = 'https://direct-collect.dy-api.com/v2/collect'
      const variations = parameters.variationsId || [];
      const body = {
        user: {
          dyid: window.DY.dyid,
          dyid_server: window.DY.dyid,
        },
        session: {
          dy: window.DY.jsession,
        },
        engagements: [
          {
            type: parameters.type || 'SLOT_CLICK',
            decisionId: parameters.decisionId,
            slotId: parameters.slotId || null,
            variations: variations,
          },
        ],
      };
      const req = await fetch(url, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          'dy-api-key': parameters.apiKey,
        },
        body: JSON.stringify(body),
      });
      if (parameters?.returnData) {
        const res = await req.json();
        return res;
      } else {
        return true;
      }
    }
  }
}
export default DynamicYield;

// window.dy_event = DynamicYield.sendEvent;
window.dy_reportUserEngagement = DynamicYield.reportUserEngagement;
